export type LoadingSpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const SPINNER_SIZE_MAP: Record<LoadingSpinnerSize, number> = {
  xs: 16,
  sm: 24,
  md: 40,
  lg: 64,
  xl: 96,
};
